const prepareAlgoliaChipImages = (colorChips) => {
  if (!Array.isArray(colorChips)) return [];

  const domainCountry =
    window.drupalSettings?.ctGeolocation?.siteLocale?.country;
  return colorChips
    .map((item) => JSON.parse(item))
    .filter(
      (item) => item.country === 'GLOBAL' || item.country === domainCountry,
    )
    .map((item) => ({
      img: item.url,
      label: item.color,
      value: item.color,
      field_is_custom: item.field_is_custom,
    }));
};

export default prepareAlgoliaChipImages;
